import { TableFilterTypesEnum } from "../../../../../../Enums";

export const headerData = [
  {
    label: `category`,
    input: 'documentCategory',
    filterType: TableFilterTypesEnum.textInput.key
},
{
    label: `documentName`,
    input: 'documentName',
    filterType: TableFilterTypesEnum.textInput.key
},
{
    label: `file-name`,
    input: 'fileName',
    filterType: TableFilterTypesEnum.textInput.key
},
{
    label: `remarks`,
    input: 'documentRemarks',
},
{
    label: `created-date`,
    isDate: true,
    input: 'createdOn',
    dateFormat: 'DD/MM/YYYY',
    filterType: TableFilterTypesEnum.datePicker.key
},
{
    label: `created-by`,
    input: 'createdBy',
    filterType: TableFilterTypesEnum.textInput.key
  },
];
